export const EXTERNAL_LINKS = {
  LEGAL_KITZ: 'https://legalkitz.com.au',
};
